<template>
    <div class="img-wrapper">
        <img :src="src" :alt="alt" loading="lazy" @load="loaded = true" :class="{ 'fade-in': loaded }" />
    </div>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps({ src: String, alt: String });
const loaded = ref(false);
</script>

<style scoped>
.img-wrapper {
    background: #eee; /* placeholder color or gradient */
    aspect-ratio: 16/9; /* keeps layout stable */
    overflow: hidden;
}
img {
    opacity: 0;
    transition: opacity 0.4s ease;
    width: 100%;
    height: auto;
    display: block;
}
img.fade-in {
    opacity: 1;
}
</style>
